import React from 'react';
import CONSTANT from './../../constant';

const UserSearchBar = () => {
    return (
        <form className="searchhome" method="GET" action={CONSTANT.component.adminSearchUser.url}>
            <i className="fa fa-search d-inline-block" />
            <input type="text" name="k" className="form-control search-bar d-inline-block" placeholder="Search by employee no, designation and department" />
        </form>
    )
}

export default UserSearchBar;